<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><a id="p2bkmk2"></a> F<span style="font-size: smaller">OR</span> E<span style="font-size: smaller">UGENE</span> M. W<span style="font-size: smaller">AITH</span></p></blockquote><blockquote><p class="left"><span style="font-size: smaller">A GENTLEMAN</span><br/>
<span style="font-size: smaller">A SCHOLAR</span><br/>
<span style="font-size: smaller">A REAL MAN</span><br/>
1912–2007</p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?0ec4c580